<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
        <i class="fa fa-trash modal-icon"></i>
        <h4 class="modal-title">削除の確認</h4>
      </div>
      <div class="modal-body">
        <input hidden name="location_id" v-model="location.id">
        <p v-show="location.location_name">
          『{{
            location.location_name
          }}』を削除してもよろしいですか？
        </p>
        <p v-show="!location.location_name">
          該当の拠点情報を削除してもよろしいですか？
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >
          キャンセル
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="emitDeleteEvent(location_index, modal_id)"
        >
          実行する
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["location", "location_index", "modal_id"],
  methods: {
    emitDeleteEvent(location_index, modal_id) {
      this.$emit("delete", {
        location_index: location_index,
        modal_id: modal_id,
      });
    },
  },
};
</script>

